import useGlobalModal from 'shared/global-modal/libs/useGlobalModal'

import { ReactNode } from 'react'

import { Button } from '../Button'
import { Spin } from '../Spin'
import Title from '../Title'

interface Props {
  children?: ReactNode
  title?: string
  cancel?: string
  onCancel?: () => void
  submit?: string | ReactNode
  onSubmit?: () => void
  submitClassname?: string
  titleContentGap?: number
  disabledSubmit?: boolean
  footerLeft?: ReactNode
  bodyClassname?: string
  isLoading?: boolean
}

const ModalWindowLayout = ({
  children,
  title,
  cancel = 'Назад',
  submit = 'Подтвердить',
  submitClassname,
  onCancel,
  onSubmit,
  titleContentGap,
  disabledSubmit = false,
  footerLeft,
  bodyClassname,
  isLoading,
}: Props) => {
  const { closeModal } = useGlobalModal()

  const handleCancel = () => {
    onCancel?.()
    closeModal()
  }

  const handleSubmit = () => {
    onSubmit?.()
  }

  return (
    <div className="h-full flex flex-col gap-6 w-full max-w-[500px] rounded-xl">
      <div
        className={`flex-1 h-full flex flex-col pt-6 px-6 overflow-auto ${bodyClassname}`}
        style={{ gap: titleContentGap ? titleContentGap : 12 }}
      >
        {title && (
          <Title
            level={4}
            className="max-w-[408px] !mb-0 !pr-11 !text-dark !leading-7 !font-bold !text-xl"
          >
            {title}
          </Title>
        )}
        {children}
      </div>
      <div className="flex items-center justify-between py-3 px-6 bg-light_gray_2 rounded-b-xl">
        <div>{footerLeft}</div>
        <div className="flex gap-3">
          <Button
            disabled={isLoading}
            onClick={handleCancel}
            className="h-auto py-2.5 px-3 text-dark leading-5 font-medium text-sm border-[1.5px] border-light_gray_3 rounded-xl"
          >
            {cancel}
          </Button>
          <Button
            disabled={disabledSubmit || isLoading}
            htmlType="submit"
            type="primary"
            onClick={onSubmit && handleSubmit}
            className={`h-10 py-2 px-4 bg-dark_blue_1 text-base text-white leading-6 font-medium rounded-xl border-none ${submitClassname}`}
          >
            {isLoading ? <Spin size="small" /> : submit}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ModalWindowLayout
